export default __webpack_public_path__ + "static/images/google_play.fa710554.png";